import React from 'react';

function LogoutIcon(props) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 17.299 14.121' {...props}>
      <path
        className='prefix__a'
        d='M10.238 13.062a.287.287 0 00.022-.149c-.007-.04.018-.073.077-.1s.088-.046.088-.061.042-.026.127-.033l.127-.011h3.441a1.7 1.7 0 001.247-.519 1.7 1.7 0 00.518-1.246V3.177a1.7 1.7 0 00-.518-1.247 1.7 1.7 0 00-1.247-.518h-3.528a.333.333 0 01-.226-.072.366.366 0 01-.11-.215 1.856 1.856 0 01-.036-.259 2.745 2.745 0 01.006-.292q.011-.176.011-.221a.34.34 0 01.1-.248.34.34 0 01.248-.1h3.535a3.061 3.061 0 012.245.932 3.06 3.06 0 01.932 2.245v7.767a3.06 3.06 0 01-.93 2.236 3.06 3.06 0 01-2.245.933h-3.531a.335.335 0 01-.226-.072.367.367 0 01-.11-.215 1.86 1.86 0 01-.035-.256 2.742 2.742 0 01.007-.29q.011-.179.011-.223z'
      />
      <path
        className='prefix__a'
        d='M.21 6.564l6-6a.706.706 0 011.2.5v3.177h4.942a.716.716 0 01.706.706v4.237a.716.716 0 01-.706.706H7.409v3.177a.7.7 0 01-1.2.5l-6-6a.693.693 0 010-.993z'
      />
    </svg>
  );
}

export default LogoutIcon;
